var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.group)?_c('div',[_c('div',{staticClass:"title my-5"},[_vm._v(_vm._s(_vm.group.name))]),_vm._l((_vm.filteredSubGroups),function(item,index){return _c('div',{key:index},[_c('SubGroup',{attrs:{"subgroup":item}})],1)})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }